

import helpers from '../_helpers/helpersFunction';

export default function Translations(props) {

	var country = helpers.getCountry()

	
	function transform(frase){
		
		if(props.placeholders){
			var placeholders = frase.match(/\$(.*?)\$/g)
			if(placeholders){
				placeholders.forEach(function(placeholder){
					//Placeholder - $Name$
					var phText = placeholder.substring(1,placeholder.length - 1);
					//phText = Name
				
					if(props.placeholders[phText]){
						frase = frase.replace(placeholder,props.placeholders[phText])
					}else{
						frase = frase.replace(placeholder,"")
					}
				})
			}
			
			return frase
		}else{
			return frase
		}
	}

	if(props.recensioni){
		var recensioni
		switch(country) {
			case "es":
				recensioni = require('./recensioni_ES');
			  break;
			case "it":
				recensioni = require('./recensioni_IT');
			  break;
			case "en":
				recensioni = require('./recensioni_EN_en');
			  break;
			default:
				recensioni = require('./recensioni_ES');
		  } 
		//divido in due variabili props.age_range che è fatto così: "18-90"
		const from = props.age_range.split("-")[0];
		const to = props.age_range.split("-")[1];
		const recensioniFiltrate = recensioni.filter(r => {
				const eta = parseInt(r["Età"]);
				return eta >= from && eta <= to;
			});
		
		const random = recensioniFiltrate.sort(() => 0.5 - Math.random());
		const quante = props.quante ? props.quante : 6
		const scelte = random.slice(0, quante)
		
		for(let i=0;i<scelte.length;i++){
			scelte[i].Recensione = transform(scelte[i].Recensione)
		}
		return scelte
	}


	if(props.coppie){
		var recensioni


		switch(country) {
			case "es":
				recensioni = require('./coppie_ES');
			  break;
			case "it":
				recensioni = require('./coppie_IT');
			  break;
			case "en":
				recensioni = require('./coppie_EN_en');
			  break;
			default:
				recensioni = require('./coppie_ES');
		  } 
		//divido in due variabili props.age_range che è fatto così: "18-90"
		const from = props.age_range.split("-")[0];
		const to = props.age_range.split("-")[1];
		const recensioniFiltrate = recensioni.filter(r => {

				var eta_splitted = r["fascia_eta_coppia"].split("-");
				var eta_from = parseInt(eta_splitted[0]);
				var eta_to = parseInt(eta_splitted[1]);
				console.log("Fascia età coppia",eta_from,eta_to)
				return eta_from >= from && eta_to <= to;
			});
		
		const random = recensioniFiltrate.sort(() => 0.5 - Math.random());
		const quante = props.quante ? props.quante : 6
		const scelte = random.slice(0, quante)
		
		for(let i=0;i<scelte.length;i++){
			scelte[i].Recensione = transform(scelte[i].Recensione)
		}
		return scelte
	}


	var notifiche;
	switch(country) {
	  case "es":
		notifiche = require('./es_ES');
		break;
	  case "fr":
		notifiche = require('./fr_FR');
		break;
	  case "it":
		notifiche = require('./it_IT');
		break;
	  case "en":
		notifiche = require('./en_EN');
		break;
	  default:
		notifiche = require('./es_ES');
	} 

	if(props.var){
		const frase = transform(notifiche.default[props.page][props.w])
		return frase
	}

	if(notifiche.default[props.page][props.w]){
		
		const frase = transform(notifiche.default[props.page][props.w])
		const theObj = {__html:frase};
		return (<item dangerouslySetInnerHTML={theObj} />);
	}else{
		return "$$$"
	}
		
	

}
